/**
 * Language picker (MPPI-00012).
 *
 * Two languages today. A <select> rather than a menu because that is what it
 * is, and because a native control handles keyboard and screen readers without
 * being reimplemented.
 */
import { LANGUAGES, useLanguageStore, type Language } from "@/store/languageStore";

export function LanguagePicker() {
  const language = useLanguageStore((s) => s.language);
  const setLanguage = useLanguageStore((s) => s.setLanguage);

  return (
    <label className="inline-flex items-center gap-1.5">
      <span className="sr-only">Interface language</span>
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value as Language)}
        title="Interface language. Arabic switches the layout to right-to-left; untranslated text stays in English."
        className="rounded-md border border-gray-300 bg-white px-2 py-1 text-xs text-gray-700"
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.native}
          </option>
        ))}
      </select>
    </label>
  );
}
